import { render, staticRenderFns } from "./DepartmentEdit.vue?vue&type=template&id=4a2fb8f2&scoped=true&"
import script from "./DepartmentEdit.vue?vue&type=script&lang=ts&"
export * from "./DepartmentEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a2fb8f2",
  null
  
)

export default component.exports